import React, { useCallback, useEffect, useRef, useState } from 'react'
import { toast } from 'helpers/UI'
import { Textarea } from 'components/common/Input'
import { requestCreateResumeComment, requestCreateArticleComment } from 'api/document'
import Image from 'components/common/Image'
import { useProfile } from 'hooks/user'

const apiMethods = {
  resume: requestCreateResumeComment,
  article: requestCreateArticleComment,
}

const submitComment = async (type, targetId, content, replyTo) => {
  try {
    const data = { content }

    if (replyTo && replyTo.id) {
      data.replyTo = replyTo.id
    }

    const res = await apiMethods[type](targetId, data)
    toast.success('评论成功')
    return res.comment
  } catch (error) {
    console.log(error)
    toast.error(error.message || '操作失败')
    return false
  }
}

const CommentForm = React.memo((props) => {
  const inputRef = useRef()
  const profile = useProfile()
  const { className, replyTo, type, targetId, onCancelReply, onSubmitted } = props
  const [content, setContent] = useState('')

  const handleSubmit = useCallback(() => {
    setContent((content) => {
      if (!content.trim().length) {
        toast.warn('请填写有效的评论内容')
        return ''
      }
      submitComment(type, targetId, content, replyTo).then((comment) => {
        onCancelReply()
        onSubmitted(comment)
        setContent('')
      })
      return content
    })
  }, [replyTo, type, targetId, onCancelReply, onSubmitted])

  const handleKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter' && (event.metaKey || event.ctrlKey) && !event.nativeEvent.isComposing && !event.repeat) {
        handleSubmit()
      }
    },
    [handleSubmit]
  )

  useEffect(() => {
    if (replyTo) {
      inputRef.current.focus()
    }
  }, [replyTo])

  return (
    <div className={`${className}`}>
      <div className="relative">
        <Textarea
          theme="none"
          className="h-24 w-full resize-none border border-gray-300/60 bg-gray-50 text-tiny shadow-inner shadow-gray-200/60 lg:h-32"
          maxLength={200}
          ref={inputRef}
          value={content}
          onKeyDown={handleKeyDown}
          onChange={setContent}
          placeholder="输入评论，最多200字"
        />
        <div className="mt-4 flex flex-col items-stretch justify-between lg:flex-row lg:items-center">
          <div className="flex items-center rounded bg-gray-100 p-4 lg:bg-transparent lg:p-0">
            <Image className="h-10 w-10 rounded-full" type="avatar" src={profile.avatar} crop="80x80" />
            <div className="ml-3">
              <div className="text-sm font-medium text-gray-500">{profile.nickname || profile.username}</div>
              {replyTo ? (
                <div className="flex items-center justify-between text-xs text-gray-400">
                  <span>
                    正在回复 <b>{replyTo.username}</b> 的评论&ensp;
                  </span>
                  <span className="cursor-pointer text-primary" onClick={onCancelReply}>
                    [取消回复]
                  </span>
                </div>
              ) : (
                <div className="text-xs text-gray-400">请文明交流，理性发言</div>
              )}
            </div>
          </div>
          <button className="button-primary mt-4 h-12 rounded px-12 text-base font-medium lg:mt-0 lg:h-11 " onClick={handleSubmit}>
            提交
          </button>
        </div>
      </div>
    </div>
  )
})

export default CommentForm
